<!-- Generic -->
<p-toast position="bottom-center" />

<!-- Reply-->
<p-toast position="bottom-center" key="reply" [life]="20000" (onClose)="onReject()">
  <ng-template let-message pTemplate="message">
    <div class="content">
      <div class="title-seciton">
        <span class="title">{{ message.summary }}</span>
      </div>
      <div class="message">{{ message.detail }}</div>
      <div class="footer">
        <p-button size="small" label="Feedback" severity="info" (onClick)="onConfirm()" />
      </div>
    </div>
  </ng-template>
</p-toast>

<!-- No Reply -->
<p-toast position="bottom-center" key="noReply" [life]="5000" (onClose)="onReject()">
  <ng-template let-message pTemplate="message">
    <div class="content">
      <div class="title-seciton">
        <span class="title"> {{ message.summary }} </span>
      </div>
      <div class="message">{{ message.detail }}</div>
    </div>
  </ng-template>
</p-toast>
